<template>
<div class="select-with-label">
  <label for="height" class="label">{{ label }}</label>
  <select name="height" :value="value" class="ingredient--types" @change="onChange">
    <option v-for="option in options || []" :value="option.value">
      {{ option.text }}
    </option>
  </select>
  <!-- <p v-if="required && value === ''" class="label" style="line-height: 1.5rem; color: rgba(256, 102, 53, 1);">* This field is required</p> -->
</div>
</template>

<script>
export default {
  name: 'base-select-with-label',
  components: {},
  props: {
    label: {
      type: String,
    },
    required: {
      type: Boolean,
    },
    value: {
      type: [String, Number],
    },
    options: {
      type: Array,
    },
    disabled: {
      type: Boolean,
    },
  },
  data: function() {
    return {};
  },
  methods: {
    onChange($event) {
      this.$emit('baseSelectChanged', $event);
    },
  },
  computed: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.select-with-label {
  background-color: transparent;
  border-color: $color-grey;
  border-style: solid;
  border-width: 0;
  display: flex;
  flex-flow: column nowrap;
  width: 100%;

  label {
    display: block;
    font-size: 1.7rem;
    margin-bottom: 1rem;
  }

  select {
    -webkit-appearance: none;
    background: $color-white;
    border: $size-input-border solid $color-input-border;
    border-radius: $size-input-border-radius;
    box-sizing: border-box;
    flex: 0 1 100%;
    font-size: 1.5rem;
    height: 4.5rem;
    letter-spacing: 0;
    margin-bottom: 1.6rem;
    padding: $size-input-padding-vertical $size-input-padding-horizontal;
    &:active,
    &:focus {
      border: 2px solid $color-action;
      outline: none;
    }
  }

  &:disabled {
    background: $color-button-disabled-bg;
    cursor: not-allowed;
  }
}
</style>
